import React, { useEffect, useState } from "react";

const uploadFileToS3 = async (file, isImage = false, uploadUrl) => {
  
    const typeNew =  isImage? file?.mime : 'image/jpg';


    // console.log("new",file,uploadUrl)
    let respUrl;
    // myHeaders.append("Content-Type", "application/json");
    // myHeaders.append("Accept", "application/json");
  
    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },

    })
      // .uploadProgress((written, total) => {
      //   let percentage = (written / total) * 100;
      //   // progrssCallback && progrssCallback(percentage);
      // })
      .then(data => {
        respUrl =  data
       console.log("datain" ,data)
        // callBack && callBack(1, data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      //  console.log("respult",respUrl)
      return respUrl
     
      
  };
  export const ImageUtils = {
    uploadFileToS3
  };